import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Vue.component('Home', require('../pages/Home.vue').default)
    },
    {
      path: '/about',
      name: 'About',
      component: Vue.component('About', require('../pages/About.vue').default)
    },
    {
      path: '/log',
      name: 'Log',
      component: Vue.component('Log', require('../pages/Log.vue').default)
    },
    {
      path: '/entry/:entryId',
      name: 'Entry',
      component: Vue.component('Entry', require('../pages/Entry.vue').default)
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Vue.component('Contact', require('../pages/Contact.vue').default)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js